import { render } from "./MainBoard.vue?vue&type=template&id=66316c24&scoped=true"
import script from "./MainBoard.vue?vue&type=script&lang=js"
export * from "./MainBoard.vue?vue&type=script&lang=js"

import "./MainBoard.vue?vue&type=style&index=0&id=66316c24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66316c24"]])

export default __exports__